import { Injectable } from '@angular/core';
import { NxSortHeaderIntl } from '@allianz/ng-aquila/table';

@Injectable({
  providedIn: 'root'
})
export class SortingService extends NxSortHeaderIntl {
  sortAscendingAriaLabel = 'sort ascending by';
  sortDescendingAriaLabel = 'sort descending by';
}
